// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectRiskWarningMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_RISK_WARN_MESSAGE);
        this.AccountID = null;
        this.Text = null;
        this.RiskRuleType = null;
        this.RiskWarnLevel = null;
    }
}
DirectRiskWarningMessage.RiskRuleWarningHeader = 'dealticket.RiskRuleWarning.Header';
DirectRiskWarningMessage.PositionLossLimitRiskRuleType = 10;
DirectRiskWarningMessage.LossLimitPerTrade = 12;
DirectRiskWarningMessage.NegativeProjectedBalanceRiskRuleType = 13;
DirectRiskWarningMessage.AvailableCashRiskRuleType = 16;
